import React from "react";
import PropTypes from "prop-types";

// Hook
import { useI18n } from "Hooks";

// Design System
import { CloseOutlined, RefreshArrowOutlined } from "@toddle-edu/ds-icons";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";

// SCSS
import classes from "./Header.scss";

const iconButtonCommonProps = {
  dsVersion: "2.0",
  variant: "neutral",
  type: "plain",
};

const Header = props => {
  const {
    testId,
    title,
    onClose,
    onClickReset,
    tooltipPlacement,
    children,
  } = props;

  const { t } = useI18n();

  if (children) return children;

  return (
    <div className={classes.container}>
      <div className={classes.titleContainer}>
        <h6>{t(title)}</h6>
      </div>

      {/* refresh chat icon button */}
      <div className={classes.rightContainer}>
        {onClickReset ? (
          <Tooltip
            tooltip={t("common:clear_chat_history")}
            showArrow={true}
            placement={tooltipPlacement || "bottom"}
          >
            <IconButton
              {...iconButtonCommonProps}
              icon={<RefreshArrowOutlined variant="neutral" />}
              onClick={onClickReset}
              testId={`${testId}-aiChatHeader-resetChat`}
            />
          </Tooltip>
        ) : null}

        {/* close chat icon button */}
        {onClose ? (
          <IconButton
            {...iconButtonCommonProps}
            icon={<CloseOutlined />}
            onClick={onClose}
            testId={`${testId}-aiChatHeader-closeChat`}
          />
        ) : null}
      </div>
    </div>
  );
};

Header.propTypes = {
  testId: PropTypes.string,
  onClose: PropTypes.func,
  title: PropTypes.string,
  onClickReset: PropTypes.func,
};

Header.defaultProps = {
  onClose: null,
  onClickReset: null,
  testId: "uicomponents-aiChat",
  title: "ai:learning_experience_assistant",
};

export default Header;
